export default __webpack_public_path__ + "img/WB_RTK_250MA_WF.cb6ebcb20d589ba3465d6de1ebf501ae.jpg";